import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import API from "@/lib/api";
import { timeAgo } from "@/lib/format";
import { Bell, BellOff } from "lucide-react";

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    // Fetch once keeping the original read state for display, then mark all read.
    API.get("/notifications").then((r) => {
      setItems(r.data);
      if (r.data.some((n) => !n.read)) API.post("/notifications/read").catch(() => {});
    }).catch(() => setItems([]));
  }, []);

  const unreadCount = (items || []).filter((n) => !n.read).length;

  return (
    <Layout>
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-serif text-2xl font-bold text-[#0F1230]">Notifiche</h1>
        {unreadCount > 0 && (
          <span data-testid="notifications-unread-count" className="bg-[#E8590C] text-white text-xs font-semibold rounded-full px-2.5 py-1">{unreadCount} nuove</span>
        )}
      </div>
      {items === null ? <p className="text-[#4A4E68]">Caricamento...</p> : items.length === 0 ? (
        <div className="bg-white rounded-[18px] border border-[#DADFEA] p-8 text-center text-[#4A4E68]">
          <BellOff size={28} className="mx-auto mb-2 text-[#C9C9D6]" />
          <p>Nessuna notifica per ora.</p>
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((n) => (
            <button key={n.id} data-testid={`notification-${n.id}`} onClick={() => n.link && navigate(n.link)}
              className={`text-left w-full rounded-[18px] border p-4 flex gap-3 items-start hover:shadow-md transition-shadow ${n.read ? "bg-white border-[#DADFEA]" : "bg-[#FFFBEF] border-[#F6DC7A]"}`}>
              <div className={`relative w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${n.read ? "bg-[#EDEDF4] text-[#4A4E68]" : "bg-[#FFF6DA] text-[#141A3A]"}`}>
                <Bell size={16} />
                {!n.read && <span data-testid={`unread-dot-${n.id}`} className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 rounded-full bg-[#E8590C] border-2 border-white" />}
              </div>
              <div className="flex-1">
                <p className={`text-sm ${n.read ? "text-[#2A2E48]" : "text-[#0F1230] font-medium"}`}>{n.text}</p>
                <p className="text-xs text-[#4A4E68]">{timeAgo(n.created_at)}</p>
              </div>
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}
